// frontend/src/api.js
import axios from 'axios';
axios.defaults.withCredentials = true;
export default axios;
